// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e8f8ccbd","453":"bf126463","732":"d6069dc8","977":"230edcdc"}[chunkId] + ".chunk.js";
};